import React from "react";

export default function CapitalAllocationReferenceCards({ formattedCapital, currency, horizon }) {
  return (
    <div className="mt-6 grid gap-4 md:grid-cols-2">
      <article className="rounded-xl border border-slate-200 bg-slate-50 p-5">
        <p className="text-xs font-semibold uppercase tracking-[0.16em] text-slate-500">Current Position</p>
        <p className="mt-3 text-xl font-semibold text-slate-950">Existing Portfolio</p>
        <p className="mt-2 text-sm leading-6 text-slate-600">Current position before any new Board-approved allocation.</p>
      </article>
      <article className="rounded-xl border border-slate-300 bg-white p-5">
        <p className="text-xs font-semibold uppercase tracking-[0.16em] text-slate-500">Economically Optimal Portfolio</p>
        <p className="mt-3 text-sm font-medium text-slate-600">Optimal Capital Requirement</p>
        <p className="mt-1 text-2xl font-semibold tracking-tight text-slate-950">{formattedCapital}</p>
        <p className="mt-2 text-sm leading-6 text-slate-600">Capital required before applying an available-capital constraint.</p>
        <p className="mt-4 text-xs text-slate-500">Currency: {currency}{horizon ? ` · Horizon: ${horizon}` : ""}</p>
      </article>
    </div>
  );
}
